import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Calendar, User } from 'lucide-react';
import api from '../utils/api';

const BlogsPage = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const response = await api.get('/blogs?published=true');
      setBlogs(response.data);
    } catch (error) {
      console.error('Error fetching blogs:', error);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#FFFDF9]">
      <section className="bg-[#2A0000] text-white py-16">
        <div className="container mx-auto px-4 md:px-8 text-center">
          <h1 className="font-heading text-4xl md:text-5xl font-bold mb-4">Our Blog</h1>
          <p className="text-lg text-white/90">Style tips, bridal guides, and ethnic fashion insights</p>
        </div>
      </section>

      <div className="container mx-auto px-4 md:px-8 py-12">
        {loading ? (
          <div className="text-center py-20">
            <p className="text-gray-600">Loading blogs...</p>
          </div>
        ) : blogs.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-gray-600 text-lg">No blog posts available yet. Check back soon!</p>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogs.map((blog, index) => (
              <motion.article
                key={blog.slug}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="bg-white rounded-sm border border-[#E5A93C]/20 overflow-hidden hover:shadow-lg transition-shadow"
              >
                {blog.thumbnail && (
                  <img
                    src={blog.thumbnail}
                    alt={blog.title}
                    className="w-full h-48 object-cover"
                  />
                )}
                <div className="p-6">
                  <div className="flex items-center space-x-4 text-sm text-gray-600 mb-3">
                    <span className="flex items-center space-x-1">
                      <User className="w-4 h-4" />
                      <span>{blog.author}</span>
                    </span>
                    <span className="flex items-center space-x-1">
                      <Calendar className="w-4 h-4" />
                      <span>{new Date(blog.created_at).toLocaleDateString()}</span>
                    </span>
                  </div>
                  <h2 className="font-heading text-xl font-bold text-[#2A0000] mb-3 hover:text-[#E5A93C] transition-colors">
                    <Link to={`/blogs/${blog.slug}`}>{blog.title}</Link>
                  </h2>
                  <p className="text-[#2C2C2C] text-sm leading-relaxed mb-4">
                    {blog.content.substring(0, 150)}...
                  </p>
                  <Link
                    to={`/blogs/${blog.slug}`}
                    className="text-[#E5A93C] hover:underline text-sm font-medium"
                  >
                    Read More →
                  </Link>
                </div>
              </motion.article>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogsPage;
